/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateFileDataAttributeSchema = z.enum(['cv'])

export type CandidateFileDataAttributeSchema = z.infer<typeof candidateFileDataAttributeSchema>
